import type { ExerciseDef } from './types'

export const hello: ExerciseDef = {
  starter: `console.log("Hello, machine!")
`,
}

export const calc: ExerciseDef = {
  starter: `// + add   - subtract   * multiply   / divide
console.log(2 + 3)
console.log(10 - 4 * 2)      // multiplication happens first: 10 - 8
console.log((10 - 4) * 2)    // brackets change the order
console.log(7 / 2)
console.log(2 ** 10)         // ** means "to the power of": 2 × 2 × … ten times
`,
}

export const firstPlot: ExerciseDef = {
  starter: `// "x => x * x" is a tiny function: give it x, it gives back x times x.
plot.fn(x => x * x, [-3, 3], { title: "x times x" })

// A list of numbers, drawn as a line:
plot.line([5, 3.4, 2.4, 1.8, 1.4, 1.15, 1, 0.9, 0.84, 0.8, 0.78], { title: "a loss going down" })
`,
}

export const broken: ExerciseDef = {
  starter: `const greeting = "hi"
console.log(greting)   // ← run this and read the error
`,
  throws: true,
}

export const answer42: ExerciseDef = {
  starter: `// Change the number so that answer is 42.
const answer = 7 * 5

console.log(answer)
`,
  solution: `const answer = 7 * 6

console.log(answer)
`,
  tests: `test("answer is 42", () => expect(answer, "answer").toBe(42))`,
}
